module.exports = {
	"ha": "vcha",
	"id": 5.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category and MSM Status, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 90.80459770114942,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#043f61"
					},
					{
						"y": 79.3103448275862,
						"dataLabels": {
							"enabled": false,
							"format": "69"
						},
						"color": "#0c4250"
					},
					{
						"y": 74.71264367816092,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#0d4440"
					},
					{
						"y": 64.36781609195403,
						"dataLabels": {
							"enabled": false,
							"format": "56"
						},
						"color": "#09472e"
					},
					{
						"y": 52.87356321839081,
						"dataLabels": {
							"enabled": false,
							"format": "46"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.74468085106383,
						"dataLabels": {
							"enabled": false,
							"format": "315"
						},
						"color": "#043f61"
					},
					{
						"y": 82.37082066869301,
						"dataLabels": {
							"enabled": false,
							"format": "271"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.11550151975683,
						"dataLabels": {
							"enabled": false,
							"format": "257"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.73252279635258,
						"dataLabels": {
							"enabled": false,
							"format": "236"
						},
						"color": "#09472e"
					},
					{
						"y": 59.57446808510638,
						"dataLabels": {
							"enabled": false,
							"format": "196"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "391"
						},
						"color": "#043f61"
					},
					{
						"y": 89.00255754475704,
						"dataLabels": {
							"enabled": false,
							"format": "348"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.86445012787725,
						"dataLabels": {
							"enabled": false,
							"format": "324"
						},
						"color": "#0d4440"
					},
					{
						"y": 75.70332480818415,
						"dataLabels": {
							"enabled": false,
							"format": "296"
						},
						"color": "#09472e"
					},
					{
						"y": 61.125319693094625,
						"dataLabels": {
							"enabled": false,
							"format": "239"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "1495"
						},
						"color": "#043f61"
					},
					{
						"y": 91.50501672240803,
						"dataLabels": {
							"enabled": false,
							"format": "1368"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.68896321070234,
						"dataLabels": {
							"enabled": false,
							"format": "1296"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.61204013377926,
						"dataLabels": {
							"enabled": false,
							"format": "1250"
						},
						"color": "#09472e"
					},
					{
						"y": 68.09364548494983,
						"dataLabels": {
							"enabled": false,
							"format": "1018"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#043f61"
					},
					{
						"y": 91.30434782608695,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.30434782608695,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0d4440"
					},
					{
						"y": 82.6086956521739,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#09472e"
					},
					{
						"y": 47.82608695652174,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "135"
						},
						"color": "#043f61"
					},
					{
						"y": 93.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "126"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.88888888888889,
						"dataLabels": {
							"enabled": false,
							"format": "120"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.81481481481481,
						"dataLabels": {
							"enabled": false,
							"format": "101"
						},
						"color": "#09472e"
					},
					{
						"y": 48.148148148148145,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.63369963369964,
						"dataLabels": {
							"enabled": false,
							"format": "272"
						},
						"color": "#043f61"
					},
					{
						"y": 87.54578754578755,
						"dataLabels": {
							"enabled": false,
							"format": "239"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.78388278388277,
						"dataLabels": {
							"enabled": false,
							"format": "226"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.52747252747253,
						"dataLabels": {
							"enabled": false,
							"format": "198"
						},
						"color": "#09472e"
					},
					{
						"y": 43.956043956043956,
						"dataLabels": {
							"enabled": false,
							"format": "120"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "735"
						},
						"color": "#043f61"
					},
					{
						"y": 94.5578231292517,
						"dataLabels": {
							"enabled": false,
							"format": "695"
						},
						"color": "#0c4250"
					},
					{
						"y": 89.65986394557824,
						"dataLabels": {
							"enabled": false,
							"format": "659"
						},
						"color": "#0d4440"
					},
					{
						"y": 81.9047619047619,
						"dataLabels": {
							"enabled": false,
							"format": "602"
						},
						"color": "#09472e"
					},
					{
						"y": 60.40816326530612,
						"dataLabels": {
							"enabled": false,
							"format": "444"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 45.19230769230769,
						"dataLabels": {
							"enabled": false,
							"format": "47"
						},
						"color": "#043f61"
					},
					{
						"y": 43.269230769230774,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#0c4250"
					},
					{
						"y": 37.5,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#0d4440"
					},
					{
						"y": 34.61538461538461,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#09472e"
					},
					{
						"y": 21.153846153846153,
						"dataLabels": {
							"enabled": false,
							"format": "22"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.09302325581395,
						"dataLabels": {
							"enabled": false,
							"format": "167"
						},
						"color": "#043f61"
					},
					{
						"y": 83.13953488372093,
						"dataLabels": {
							"enabled": false,
							"format": "143"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.32558139534885,
						"dataLabels": {
							"enabled": false,
							"format": "133"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.67441860465115,
						"dataLabels": {
							"enabled": false,
							"format": "125"
						},
						"color": "#09472e"
					},
					{
						"y": 57.55813953488372,
						"dataLabels": {
							"enabled": false,
							"format": "99"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.45161290322581,
						"dataLabels": {
							"enabled": false,
							"format": "299"
						},
						"color": "#043f61"
					},
					{
						"y": 75.48387096774194,
						"dataLabels": {
							"enabled": false,
							"format": "234"
						},
						"color": "#0c4250"
					},
					{
						"y": 67.0967741935484,
						"dataLabels": {
							"enabled": false,
							"format": "208"
						},
						"color": "#0d4440"
					},
					{
						"y": 63.87096774193548,
						"dataLabels": {
							"enabled": false,
							"format": "198"
						},
						"color": "#09472e"
					},
					{
						"y": 50.32258064516129,
						"dataLabels": {
							"enabled": false,
							"format": "156"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.93251533742331,
						"dataLabels": {
							"enabled": false,
							"format": "790"
						},
						"color": "#043f61"
					},
					{
						"y": 71.41104294478528,
						"dataLabels": {
							"enabled": false,
							"format": "582"
						},
						"color": "#0c4250"
					},
					{
						"y": 64.9079754601227,
						"dataLabels": {
							"enabled": false,
							"format": "529"
						},
						"color": "#0d4440"
					},
					{
						"y": 62.20858895705521,
						"dataLabels": {
							"enabled": false,
							"format": "507"
						},
						"color": "#09472e"
					},
					{
						"y": 49.4478527607362,
						"dataLabels": {
							"enabled": false,
							"format": "403"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -9.195402298850574,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.658227848101266,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.797101449275366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.846153846153841,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.85714285714286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.255319148936165,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.968253968253963,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.166051660516602,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.171206225680939,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.94915254237288,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.997442455242968,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.896551724137934,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.64197530864198,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.256756756756754,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.494983277591972,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.263157894736848,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.5493827160493874,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.56,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.695652173913048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -42.10526315789473,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.761904761904767,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.833333333333332,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.64356435643564,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.366300366300365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.132352941176471,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.4393305439330515,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.389380530973447,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -39.39393939393939,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.442176870748295,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.179856115107917,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.649468892261003,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.24584717607974,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -54.807692307692314,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.255319148936165,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -38.888888888888886,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.9069767441860517,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.371257485029943,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.99300699300699,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.015037593984962,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.799999999999997,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.548387096774197,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.739130434782606,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.807692307692313,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.212121212121215,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.0674846625766916,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.329113924050628,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.106529209621995,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.15879017013232,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.512820512820518,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=87"
			},
			{
				"x": 9,
				"text": "30-39<br>n=329"
			},
			{
				"x": 15,
				"text": "40-49<br>n=391"
			},
			{
				"x": 21,
				"text": ">=50<br>n=1495"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=23"
			},
			{
				"x": 34,
				"text": "30-39<br>n=135"
			},
			{
				"x": 40,
				"text": "40-49<br>n=273"
			},
			{
				"x": 46,
				"text": ">=50<br>n=735"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=104"
			},
			{
				"x": 59,
				"text": "30-39<br>n=172"
			},
			{
				"x": 65,
				"text": "40-49<br>n=310"
			},
			{
				"x": 71,
				"text": ">=50<br>n=815"
			}
		],
		"dataTable": {
			"MSM:<30": [
				87,
				79,
				69,
				65,
				56,
				46
			],
			"MSM:30-39": [
				329,
				315,
				271,
				257,
				236,
				196
			],
			"MSM:40-49": [
				391,
				391,
				348,
				324,
				296,
				239
			],
			"MSM:>=50": [
				1495,
				1495,
				1368,
				1296,
				1250,
				1018
			],
			"Non-MSM:<30": [
				23,
				23,
				21,
				21,
				19,
				11
			],
			"Non-MSM:30-39": [
				135,
				135,
				126,
				120,
				101,
				65
			],
			"Non-MSM:40-49": [
				273,
				272,
				239,
				226,
				198,
				120
			],
			"Non-MSM:>=50": [
				735,
				735,
				695,
				659,
				602,
				444
			],
			"Unknown:<30": [
				104,
				47,
				45,
				39,
				36,
				22
			],
			"Unknown:30-39": [
				172,
				167,
				143,
				133,
				125,
				99
			],
			"Unknown:40-49": [
				310,
				299,
				234,
				208,
				198,
				156
			],
			"Unknown:>=50": [
				815,
				790,
				582,
				529,
				507,
				403
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_5.json
// module id = 306
// module chunks = 0